"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarWrap = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
function shouldForwardProp(propName) {
  switch (propName) {
    case "size":
      return false;
    default:
      return true;
  }
}
const AvatarWrap = (0, _styled.default)("div", {
  shouldForwardProp
})`
    height: ${_ref => {
  let {
    size
  } = _ref;
  return size;
}}px;

    & > * {
        z-index: 0;
    }

    // When an avatar has focus, lift it above its siblings to ensure the focus ring is visible.
    & > :focus,
    // Lift when the user hovers the avatar as well. This allows their mouse to travel to the
    // contact card more easily without clipping neighboring Avatars.
    & > :hover {
        z-index: 1;
    }

    &:not(:first-of-type) {
        margin-left: -2px;
    }
`;
exports.AvatarWrap = AvatarWrap;
//# sourceMappingURL=AvatarWrap.js.map